<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="mt-2">
                <b-col cols="12" md="4">
                    <ValidationProvider name="emergency_person_name"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('full_name')">
                            <b-form-input v-model="formData.emergency_person_name"
                                          :state="errors[0] ? false : null"
                                          :placeholder="$t('full_name')"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="emergency_person_phone"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('phone_number')">
                            <b-form-input v-model="formData.emergency_person_phone"
                                          :state="errors[0] ? false : null"
                                          :placeholder="$t('phone_number')"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="emergency_person_relation"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('Relationship')">
                            <b-form-input v-model="formData.emergency_person_relation"
                                          :state="errors[0] ? false : null"
                                          :placeholder="$t('Relationship')"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" @click="updateForm" :disabled="formProcess">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components

// Services

// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
import StaffService from "@/services/StaffService";

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    props: {
        staffInformation: {
            type: Object,
            default: null,
        }
    },
    created() {
        this.formId = this.$route.params.id
        this.formData.emergency_person_name = this.staffInformation.emergency_person_name
        this.formData.emergency_person_phone = this.staffInformation.emergency_person_phone
        this.formData.emergency_person_relation = this.staffInformation.emergency_person_relation
        this.formData.name=this.staffInformation.name
        this.formData.surname=this.staffInformation.surname
        this.formData.username=this.staffInformation.username
        this.formData.working_status=this.staffInformation.working_status
        this.formData.contract_type=this.staffInformation.contract_type


    },
    data() {
        return {
            formId: null,
            formData:{
                emergency_person_name:null,
                emergency_person_phone:null,
                emergency_person_relation:null
            },

            formProcess: false
        }
    },
    methods: {
        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid && this.formId) {
                let formData = {
                    ...this.formData
                }

                this.formProcess = true
                StaffService.update(this.formId, formData)
                    .then(response => {
                        this.$emit('updateFormSuccess', true);
                        this.$toast.success(this.$t('api.' + response.data.message));
                    })
                    .catch(e => {
                        this.showErrors(e, this.$refs.formModalValidate)
                    })
                    .finally(() => {
                        this.formProcess = false
                    })
            }
        }
    }
}
</script>
